import { MessageCircle } from "lucide-react";

const WhatsAppFloat = () => (
  <a
    href="https://wa.me/254700000000?text=Hi%20Precision%20Mobile%20Auto%2C%20I%20need%20a%20service"
    target="_blank"
    rel="noopener noreferrer"
    className="fixed bottom-5 right-5 z-50 flex items-center gap-2 bg-[hsl(142,70%,42%)] text-primary-foreground rounded-full px-5 py-3.5 shadow-2xl hover:bg-[hsl(142,70%,38%)] hover:scale-105 active:scale-95 transition-all duration-300 animate-pulse-glow group"
    aria-label="Chat on WhatsApp"
  >
    <MessageCircle className="h-5 w-5 sm:h-6 sm:w-6" />
    <span className="font-heading text-xs sm:text-sm uppercase tracking-wider hidden sm:inline">
      WhatsApp
    </span>
  </a>
);

export default WhatsAppFloat;
